/* ============================================================
   PLURALIST CO. — Main JS v2.1
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── SCROLL REVEALS ── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    reveals.forEach(el => io.observe(el));
  }

  /* ── ACTIVE NAV ── */
  const path = window.location.pathname;
  document.querySelectorAll('.hd__nav a').forEach(a => {
    const href = a.getAttribute('href');
    if (href === path || (href !== '/' && path.startsWith(href))) a.classList.add('is-active');
  });

  /* ── HAMBURGER NAV ── */
  const burger = document.querySelector('.hd__burger');
  const nav    = document.querySelector('.hd__nav');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── HERO GIF — hover/touch to play, stop on leave/release ── */
  const heroGifWrap = document.getElementById('hero-gif-wrap');
  const heroGifEl   = document.getElementById('hero-gif');

  if (heroGifWrap && heroGifEl) {
    const gifSrc = heroGifEl.dataset.src;
    let gifLoaded = false;

    function gifPlay() {
      if (!gifSrc) return;
      if (!gifLoaded) { heroGifEl.src = gifSrc; gifLoaded = true; }
      else { heroGifEl.src = ''; heroGifEl.src = gifSrc; }
      heroGifWrap.classList.add('is-playing');
    }
    function gifStop() {
      heroGifEl.src = '';
      heroGifWrap.classList.remove('is-playing');
    }

    heroGifWrap.addEventListener('mouseenter',  gifPlay);
    heroGifWrap.addEventListener('mouseleave',  gifStop);
    heroGifWrap.addEventListener('touchstart',  e => { e.preventDefault(); gifPlay(); }, { passive: false });
    heroGifWrap.addEventListener('touchend',    e => { e.preventDefault(); gifStop(); }, { passive: false });
    heroGifWrap.addEventListener('touchcancel', gifStop);
  }

  /* ── SP-404 ── */
  const pads   = document.querySelectorAll('.sp__pad');
  const lcdEl  = document.getElementById('sp-lcd');
  const vuBars = document.querySelectorAll('.sp__vu-bar');
  const roleEl = document.getElementById('sp-role');

  if (pads.length) {
    const MSGS = {
      A1: 'A1 — ARTIST. Make the sound.',
      A2: 'A2 — PLURALIST. Own the archive.',
      B1: 'B1 — FILM MAKER. Document the moment.',
      B2: 'B2 — ARCHIVIST. Preserve what matters.'
    };

    const audioEls = {};
    pads.forEach(pad => {
      const url = pad.dataset.sound;
      if (url && url.trim() !== '') {
        const a = new Audio(url);
        a.preload = 'auto';
        audioEls[pad.dataset.id] = a;
      }
    });

    let selected = null, holdTimer = null, vuTick = null, lcdTick = null;

    function lcd(msg) {
      if (!lcdEl) return;
      clearInterval(lcdTick);
      lcdEl.textContent = '';
      let i = 0;
      lcdTick = setInterval(() => {
        lcdEl.textContent += msg[i++];
        if (i >= msg.length) clearInterval(lcdTick);
      }, 30);
    }

    function vu(on) {
      clearInterval(vuTick);
      if (!on) { vuBars.forEach(b => b.classList.remove('lit')); return; }
      vuTick = setInterval(() => {
        const n = Math.floor(Math.random() * vuBars.length) + 1;
        vuBars.forEach((b, i) => b.classList.toggle('lit', i < n));
      }, 110);
    }

    function stopAll() {
      Object.values(audioEls).forEach(a => { a.pause(); a.currentTime = 0; a.loop = false; });
    }

    function triggerPad(pad) {
      const id = pad.dataset.id;
      const audio = audioEls[id];
      if (selected === id) {
        selected = null;
        pads.forEach(p => p.classList.remove('is-on', 'is-held'));
        clearTimeout(holdTimer);
        stopAll();
        lcd('SELECT YOUR ROLE_');
        vu(false);
        if (roleEl) roleEl.value = '';
        return;
      }
      stopAll();
      clearTimeout(holdTimer);
      pads.forEach(p => p.classList.remove('is-on', 'is-held'));
      selected = id;
      pad.classList.add('is-on');
      lcd(MSGS[id]);
      vu(true);
      if (roleEl) roleEl.value = id + ' — ' + pad.querySelector('.sp__pad-name').textContent;
      if (audio) { audio.loop = false; audio.currentTime = 0; audio.play().catch(() => {}); }
      holdTimer = setTimeout(() => {
        if (selected === id && audio) {
          pad.classList.remove('is-on');
          pad.classList.add('is-held');
          audio.loop = true;
          audio.currentTime = 0;
          audio.play().catch(() => {});
        }
      }, 400);
    }

    function releasePad(pad) {
      const id = pad.dataset.id;
      clearTimeout(holdTimer);
      if (pad.classList.contains('is-held')) {
        pad.classList.remove('is-held');
        pad.classList.add('is-on');
        const audio = audioEls[id];
        if (audio) { audio.loop = false; }
      }
    }

    pads.forEach(pad => {
      pad.addEventListener('mousedown',  () => triggerPad(pad));
      pad.addEventListener('mouseup',    () => releasePad(pad));
      pad.addEventListener('mouseleave', () => releasePad(pad));
      pad.addEventListener('touchstart', e => { e.preventDefault(); triggerPad(pad); }, { passive: false });
      pad.addEventListener('touchend',   e => { e.preventDefault(); releasePad(pad); }, { passive: false });
      pad.addEventListener('keydown',    e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); triggerPad(pad); } });
      pad.addEventListener('keyup',      e => { if (e.key === 'Enter' || e.key === ' ') releasePad(pad); });
    });

    lcd('SELECT YOUR ROLE_');
  }

  /* ── CATALOG FILTER ── */
  const fBtns  = document.querySelectorAll('.cat-filter__btn');
  const cItems = document.querySelectorAll('.citem');
  if (fBtns.length) {
    fBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        fBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const f = btn.dataset.filter;
cItems.forEach(item => { item.style.display = (f === 'all' || item.dataset.type.toUpperCase() === f.toUpperCase()) ? '' : 'none'; });
      });
    });
  }

});
/* ── JOIN QUIZ ── */
(function() {

  var JOIN_QUESTIONS = [
    { text: "When you get a new creative idea, your first instinct is to:", opts: [ { l:"A", t:"Turn it into a real project" }, { l:"B", t:"Understand what it means" }, { l:"C", t:"Make it feel different from anything else" }, { l:"D", t:"Feel where the idea wants to take you" } ] },
    { text: "People usually come to you for:", opts: [ { l:"A", t:"Structure, direction, or execution" }, { l:"B", t:"Clarity, language, or perspective" }, { l:"C", t:"Bold ideas, courage, or a new way forward" }, { l:"D", t:"Emotional honesty, grounding, or presence" } ] },
    { text: "Your creative work is strongest when it:", opts: [ { l:"A", t:"Becomes something people can experience" }, { l:"B", t:"Tells a meaningful story" }, { l:"C", t:"Challenges what people expected" }, { l:"D", t:"Makes people feel deeply" } ] },
    { text: "In a group, you naturally become the person who:", opts: [ { l:"A", t:"Makes the plan" }, { l:"B", t:"Connects the dots" }, { l:"C", t:"Pushes the idea further" }, { l:"D", t:"Holds the energy of the room" } ] },
    { text: "Your relationship to rules is:", opts: [ { l:"A", t:"Rules can help create structure" }, { l:"B", t:"Rules should be understood before they are changed" }, { l:"C", t:"Rules are meant to be questioned" }, { l:"D", t:"Rules matter less than truth and feeling" } ] },
    { text: "You feel most alive when you are:", opts: [ { l:"A", t:"Building something from the ground up" }, { l:"B", t:"Helping people understand something deeper" }, { l:"C", t:"Creating something no one has seen before" }, { l:"D", t:"Expressing something honest from within" } ] },
    { text: "Your art usually begins with:", opts: [ { l:"A", t:"A clear goal, project, or vision" }, { l:"B", t:"A question, story, or idea" }, { l:"C", t:"A need to experiment or break form" }, { l:"D", t:"A feeling, memory, or spiritual pull" } ] },
    { text: "Your biggest creative gift is:", opts: [ { l:"A", t:"Execution" }, { l:"B", t:"Meaning" }, { l:"C", t:"Originality" }, { l:"D", t:"Presence" } ] },
    { text: "Your biggest creative challenge is:", opts: [ { l:"A", t:"Being too focused on finishing or controlling the outcome" }, { l:"B", t:"Overthinking before starting" }, { l:"C", t:"Starting many things without finishing them" }, { l:"D", t:"Absorbing too much emotion or waiting to feel inspired" } ] },
    { text: "Your ideal creative legacy is:", opts: [ { l:"A", t:"They built something that lasted." }, { l:"B", t:"They helped people understand themselves." }, { l:"C", t:"They changed the way people thought." }, { l:"D", t:"They made people feel seen." } ] }
  ];

  var JOIN_SINGLE = {
    A: { type:"The Builder",    sub:"You are the Pluralist who makes the vision real.",           body:"You turn ideas into projects, spaces, systems, albums, events, brands, and experiences. You are not just inspired by creativity — you want to give it form.",             gift:"Execution",   power:"Structure",       challenge:"Letting the work breathe",        phrase:"I make the vision real.",              pad:"A1", padName:"Curator" },
    B: { type:"The Translator", sub:"You are the Pluralist who gives language to the vision.",    body:"You help people understand what they are feeling, seeing, hearing, and experiencing. You connect ideas, cultures, people, and stories.",                                  gift:"Meaning",     power:"Communication",   challenge:"Not overthinking before creating", phrase:"I help people understand the vision.", pad:"B2", padName:"Archivist" },
    C: { type:"The Disruptor",  sub:"You are the Pluralist who creates what does not exist yet.", body:"You question boxes, genres, rules, labels, and expectations. You are here to push culture forward and open doors for new forms of expression.",                           gift:"Originality", power:"Courage",         challenge:"Finishing what you start",         phrase:"I break the box so something new can live.", pad:"A2", padName:"Collector" },
    D: { type:"The Vessel",     sub:"You are the Pluralist who channels the soul of the work.",   body:"You create from feeling, memory, spirit, body, and lived experience. Your work carries emotional truth. You do not just make art — you let the work move through you.", gift:"Presence",    power:"Emotional truth", challenge:"Protecting your energy",           phrase:"I let the work move through me.",      pad:"B1", padName:"Film Maker" }
  };

  var JOIN_TIE = {
    "A+B": { type:"The Architect", body:"You build with meaning. Strong at creating systems, brands, events, and projects that help people understand something deeper.", pad:"A1", padName:"Curator" },
    "B+C": { type:"The Prophet",   body:"You see what others cannot see yet. You use language, art, and ideas to wake people up.",                                        pad:"A2", padName:"Collector" },
    "C+D": { type:"The Channel",   body:"You create from raw feeling and experimentation. Your work is emotional, unexpected, and alive.",                                 pad:"B1", padName:"Film Maker" },
    "A+D": { type:"The Ritualist", body:"You create containers for feeling. You know how to turn emotion, spirit, and memory into real experiences.",                      pad:"B1", padName:"Film Maker" },
    "A+C": { type:"The Innovator", body:"You are both practical and experimental. You break the rules, then build something stronger.",                                    pad:"A2", padName:"Collector" },
    "B+D": { type:"The Healer",    body:"You help people understand what they feel. Your work makes people feel seen, held, and less alone.",                              pad:"B2", padName:"Archivist" }
  };

  var JOIN_PAD_INFO = {
    A1: { name:"Curator",    desc:"You shape what gets preserved and how the archive speaks." },
    A2: { name:"Collector",  desc:"You find, hold, and honor the rare and the overlooked." },
    B1: { name:"Film Maker", desc:"You document what words alone cannot carry." },
    B2: { name:"Archivist",  desc:"You keep the record so nothing is lost." }
  };

  var joinCurrent    = 0;
  var joinAnswers    = {};
  var joinSelected   = null;
  var joinResultData = null;
  var joinChosenPad  = null;

  function joinInit() {
    if (!document.getElementById('join-quiz-section')) return;
    document.querySelectorAll('.join-pad').forEach(function(pad) {
      pad.addEventListener('click', function() {
        window.joinSelectPad(this.dataset.pad);
      });
    });
    joinCheckURLParams();
  }

  function joinRenderQuestion() {
    var q = JOIN_QUESTIONS[joinCurrent];
    document.getElementById('join-q-num').textContent  = String(joinCurrent + 1).padStart(2, '0');
    document.getElementById('join-q-text').textContent = q.text;
    document.getElementById('join-q-progress').style.width = ((joinCurrent / JOIN_QUESTIONS.length) * 100) + '%';
    var nextBtn = document.getElementById('join-q-next');
    nextBtn.textContent = joinCurrent === JOIN_QUESTIONS.length - 1 ? 'See my result' : 'Next';
    nextBtn.disabled = true;
    joinSelected = null;
    var optsEl = document.getElementById('join-q-opts');
    optsEl.innerHTML = '';
    q.opts.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'join-opt';
      btn.innerHTML = '<span class="join-opt-letter">' + opt.l + '</span><span>' + opt.t + '</span>';
      btn.onclick = function() { joinSelectOpt(opt.l); };
      optsEl.appendChild(btn);
    });
    var section = document.getElementById('join-quiz-section');
    section.classList.remove('join-fade-in');
    void section.offsetWidth;
    section.classList.add('join-fade-in');
  }

  function joinSelectOpt(letter) {
    joinSelected = letter;
    document.querySelectorAll('.join-opt').forEach(function(b) { b.classList.remove('active'); });
    document.querySelectorAll('.join-opt')[['A','B','C','D'].indexOf(letter)].classList.add('active');
    document.getElementById('join-q-next').disabled = false;
  }

  window.joinNextQuestion = function() {
    if (!joinSelected) return;
    joinAnswers[joinCurrent] = joinSelected;
    if (joinCurrent < JOIN_QUESTIONS.length - 1) {
      joinCurrent++;
      joinRenderQuestion();
    } else {
      joinComputeAndShowResult();
    }
  };

  function joinComputeAndShowResult() {
    var counts = { A:0, B:0, C:0, D:0 };
    Object.keys(joinAnswers).forEach(function(k) { counts[joinAnswers[k]]++; });
    var max = Math.max(counts.A, counts.B, counts.C, counts.D);
    var winners = Object.keys(counts).filter(function(k) { return counts[k] === max; }).sort();
    if (winners.length === 1) {
      joinResultData = Object.assign({}, JOIN_SINGLE[winners[0]], { kind:'single' });
    } else if (winners.length === 2) {
      joinResultData = Object.assign({}, JOIN_TIE[winners[0] + '+' + winners[1]], { kind:'tie' });
    } else {
      joinResultData = Object.assign({}, JOIN_SINGLE[winners[0]], { kind:'single' });
    }
    joinShowResult();
  }

  function joinShowResult() {
    document.getElementById('join-quiz-section').style.display = 'none';
    var card = document.getElementById('join-result-card');
    card.style.display = 'block';
    card.classList.add('join-fade-in');
    document.getElementById('join-r-type').textContent   = joinResultData.type;
    document.getElementById('join-r-sub').textContent    = joinResultData.sub || '';
    document.getElementById('join-r-body').textContent   = joinResultData.body;
    document.getElementById('join-r-phrase').textContent = joinResultData.phrase ? '"' + joinResultData.phrase + '"' : '';
    var statsEl = document.getElementById('join-r-stats');
    statsEl.innerHTML = '';
    if (joinResultData.kind === 'single') {
      [['Gift', joinResultData.gift], ['Power', joinResultData.power], ['Challenge', joinResultData.challenge]].forEach(function(pair) {
        statsEl.innerHTML += '<div class="join-stat-row"><span class="join-stat-label">' + pair[0] + '</span><span class="join-stat-val">' + pair[1] + '</span></div>';
      });
    }
    document.getElementById('join-r-cue').innerHTML =
      'Based on your answers, your natural home in the archive is <span>' + joinResultData.pad + ' - ' + joinResultData.padName + '</span>. You can confirm or choose a different role below.';
    joinChosenPad = joinResultData.pad;
  }

  window.joinShowForm = function() {
    document.getElementById('join-result-card').style.display = 'none';
    var fs = document.getElementById('join-form-section');
    fs.style.display = 'block';
    fs.classList.add('join-fade-in');
    document.getElementById('join-form-type-name').textContent = joinResultData.type;
    window.joinSelectPad(joinResultData.pad);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.joinSelectPad = function(id) {
    joinChosenPad = id;
    document.querySelectorAll('.join-pad').forEach(function(p) { p.classList.remove('active'); });
    var padEl = document.getElementById('join-pad-' + id);
    if (padEl) padEl.classList.add('active');
    window.joinUpdateLCD();
    joinValidateForm();
  };

  window.joinUpdateLCD = function() {
    var name   = document.getElementById('join-f-name').value.trim();
    var email  = document.getElementById('join-f-email').value.trim();
    var sms    = document.getElementById('join-f-sms').value.trim();
    var social = document.getElementById('join-f-social').value.trim();
    var lcd    = document.getElementById('join-lcd-display');
    var lines  = [];
    if (joinChosenPad) lines.push('PAD ' + joinChosenPad + ' / ' + JOIN_PAD_INFO[joinChosenPad].name.toUpperCase());
    else               lines.push('SELECT YOUR PAD');
    if (name)          lines.push('NAME: ' + name.toUpperCase());
    if (email)         lines.push('MAIL: ' + email.toLowerCase());
    if (sms)           lines.push('SMS:  ' + sms);
    if (social)        lines.push('HNDL: ' + (social.charAt(0) === '@' ? social : '@' + social));
    if (joinResultData) lines.push('TYPE: ' + joinResultData.type.toUpperCase());
    lcd.innerHTML = lines.join('<br>') + '<span class="join-lcd-cursor"></span>';
    joinValidateForm();
  };

  function joinValidateForm() {
    var name  = document.getElementById('join-f-name').value.trim();
    var email = document.getElementById('join-f-email').value.trim();
    document.getElementById('join-submit-btn').disabled = !(joinChosenPad && name.length > 0 && email.indexOf('@') > -1);
  }

  window.joinHandleSubmit = function() {
    var name   = document.getElementById('join-f-name').value.trim();
    var email  = document.getElementById('join-f-email').value.trim();
    var sms    = document.getElementById('join-f-sms').value.trim();
    var social = document.getElementById('join-f-social').value.trim();
    if (!name || !email || !joinChosenPad) return;
    // emailjs.send('SERVICE_ID', 'TEMPLATE_ID', {
    //   name: name, email: email, sms: sms, social: social,
    //   pad: joinChosenPad,
    //   role: JOIN_PAD_INFO[joinChosenPad].name,
    //   pluralist_type: joinResultData.type
    // });
    joinShowSuccess(name);
  };

  function joinShowSuccess(name) {
    document.getElementById('join-form-section').style.display = 'none';
    var ss = document.getElementById('join-success-section');
    ss.style.display = 'block';
    ss.classList.add('join-fade-in');
    document.getElementById('join-success-type-display').textContent = joinResultData.type;
    document.getElementById('join-success-message').textContent =
      name + ", you are in the archive as " + JOIN_PAD_INFO[joinChosenPad].name + ' ' + joinChosenPad + ". We will be in touch.";
  }

  window.joinRestartQuiz = function() {
    joinCurrent = 0; joinAnswers = {}; joinSelected = null;
    joinResultData = null; joinChosenPad = null;
    document.getElementById('join-result-card').style.display     = 'none';
    document.getElementById('join-form-section').style.display    = 'none';
    document.getElementById('join-success-section').style.display = 'none';
    document.getElementById('join-quiz-section').style.display    = 'block';
    document.getElementById('join-f-name').value   = '';
    document.getElementById('join-f-email').value  = '';
    document.getElementById('join-f-sms').value    = '';
    document.getElementById('join-f-social').value = '';
    document.querySelectorAll('.join-pad').forEach(function(p) { p.classList.remove('active'); });
    document.getElementById('join-lcd-display').innerHTML = 'SELECT YOUR PAD<span class="join-lcd-cursor"></span>';
    joinRenderQuestion();
  };

  function joinCheckURLParams() {
    var params = new URLSearchParams(window.location.search);
    var role   = params.get('role');
    var email  = params.get('email');
    if (role) {
      var padMap = { 'curator':'A1', 'collector':'A2', 'filmmaker':'B1', 'archivist':'B2', 'A1':'A1', 'A2':'A2', 'B1':'B1', 'B2':'B2' };
      var pad = padMap[role.toLowerCase()];
      if (pad) {
        joinResultData = { type: JOIN_PAD_INFO[pad].name, kind: 'prefill', pad: pad, padName: JOIN_PAD_INFO[pad].name };
        document.getElementById('join-quiz-section').style.display = 'none';
        window.joinShowForm();
        if (email) {
          document.getElementById('join-f-email').value = email;
          window.joinUpdateLCD();
        }
        return;
      }
    }
    joinRenderQuestion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', joinInit);
  } else {
    joinInit();
  }

})();
// Hero image hover — swap poster to gif
document.querySelectorAll('.hero__media').forEach(el => {
  el.addEventListener('mouseenter', () => el.classList.add('is-playing'));
  el.addEventListener('mouseleave', () => el.classList.remove('is-playing'));
});